import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { ICompany } from "@/data/companies";
import { IOpenable } from "@/eworkitComponents";
import { Flex, inDialogModal } from "@/eworkitComponents";
import { IAnimated } from "@/eworkitComponents";
import { CloseButton } from "@/views/components/CloseButton";
import { StyledModal } from "@/views/components/Modal";

import { CompanyLogoEdit } from "./CompanyLogoEdit";

export interface ICompanyLogoEditDialogModalProps {
  source: ICompany;
  onUpdate?: (company: ICompany) => void;
}

const CompanyLogoEditModal: FC<ICompanyLogoEditDialogModalProps & IOpenable & IAnimated> = ({
  source,
  onUpdate,
  ...openableProps
}) => {
  const { t } = useTranslation("session");

  return (
    <StyledModal>
      <Flex direction="column" padding={["xl"]} innerMargin="md">
        <Flex direction="row" justify="space-between">
          <Header size="md" weight="bold" color="black">
            {t("COMPANY.MY_COMPANY.DATA.LOGO_EDIT_DIALOG.HEADER")}
          </Header>

          <CloseButton onClick={openableProps.onClose} testName="close" />
        </Flex>

        <CompanyLogoEdit
          onCancel={openableProps.onClose}
          source={source}
          initialValues={{ logo: source.logo }}
          onUpdate={onUpdate}
        />
      </Flex>
    </StyledModal>
  );
};

export const CompanyLogoEditDialogModal = inDialogModal(CompanyLogoEditModal);
